<div class="display-flex flex-column h-100 home-dashboard-container">
  <div class="image-container display-flex flex-column justify-content-center align-items-center grid-gap-64">
    <img width="330" height="211" src="/src/assets/logo/propUpLogoLarge.png" />
  </div>
</div>
